'use client';

import dynamic from 'next/dynamic';

export * from '@cat-ecom/pcc-components';

export const Portal = dynamic(
  () =>
    import('@cat-ecom/pcc-components/src/components/common/portal').then(
      (mod) => mod.Portal
    ),
  { ssr: false }
);
